import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const services = [{
  name: "Ant Control",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/professional_ant_control_treatment.png"
}, {
  name: "Termite Treatment",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/termite_inspection_and_treatment.png"
}, {
  name: "Spider Removal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/spider_web_removal_service.png"
}, {
  name: "Mosquito Control",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/outdoor_mosquito_misting_service.png"
}, {
  name: "Roach Elimination",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/cockroach_extermination_process.png"
}, {
  name: "Millipede Defense",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/millipede_pest_barrier_protection.png"
}];
export default function UltimateServices() {
  return <section data-section-id="223327" id="defend-your-domain" className="bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/pest_texture_pattern.png)] bg-cover bg-center opacity-10 mix-blend-multiply" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-primary drop-shadow-none">
            Defend Your Domain
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => <Link key={i} to={service.name === "Termite Treatment" ? "/TermiteTreatmentPage" : service.name === "Mosquito Control" ? "/MosquitoControlPage" : "/PestControlPage"} data-index={i} className="group block relative overflow-hidden bg-card border border-border">
              <AspectRatio ratio={4 / 5}>
                <img src={service.image} alt={service.name} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/20 to-transparent pointer-events-none transition-opacity duration-500" />

                {}
                <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-primary/60 via-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                {}
                <div className="absolute bottom-0 left-0 right-0 p-6 z-10 flex flex-col justify-end h-full">
                  <h3 className="font-default text-3xl font-bold uppercase text-white leading-none tracking-tight drop-shadow-none transition-transform duration-500 group-hover:-translate-y-1">
                    {service.name}
                  </h3>
                  <p className="font-serif text-white/90 text-sm mt-2 transition-transform duration-500 group-hover:-translate-y-1">
                    {service.name === "Termite Treatment" ? <>Professional <Link to="/TermiteTreatmentPage" className="underline decoration-primary underline-offset-2 hover:text-primary transition-colors">termite treatment</Link> for your home.</> : service.name === "Mosquito Control" ? <>Effective <Link to="/MosquitoControlPage" className="underline decoration-primary underline-offset-2 hover:text-primary transition-colors">mosquito control solutions</Link>.</> : <>Reliable <Link to="/PestControlPage" className="underline decoration-primary underline-offset-2 hover:text-primary transition-colors">pest control services</Link> you can trust.</>}
                  </p>
                </div>
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}